"use strict";import{IconHelpOutline as e}from"../src/elements/IconHelpOutline.js";import{defineElement as l}from"@spectrum-web-components/base/src/define-element.js";l("sp-icon-help-outline",e);
//# sourceMappingURL=sp-icon-help-outline.js.map
